"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.dataDefToColumns = exports.routesFromPrefix = void 0;
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var Search_1 = __importDefault(require("@material-ui/icons/Search"));
var IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));
var Delete_1 = __importDefault(require("@material-ui/icons/Delete"));
var utils_1 = require("../utils");
var delete_1 = require("../data/delete");
var Utils = __importStar(require("./pre/utils"));
var DeleteIconButton = utils_1.withStyles(function (theme) { return ({
    colorPrimary: {
        color: theme.palette.error.main,
        '&:hover': {
            color: theme.palette.error.dark
        }
    }
}); })(IconButton_1["default"]);
function lastColumn(children) {
    return {
        name: 'id',
        label: 'Action',
        render: function LastColumn(x) {
            var id = 0;
            if (x.uuid) {
                id = x.uuid;
            }
            else {
                if (x.id)
                    id = x.id;
            }
            return children(id);
        }
    };
}
function linkDetailColumn(urlPrefix, detailUrlPrefix) {
    var finalUrlPrefix = urlPrefix + (detailUrlPrefix ? "/" + detailUrlPrefix : '');
    return lastColumn(function (id) { return (react_1["default"].createElement(react_router_dom_1.Link, { to: finalUrlPrefix + "/" + id + "/detail" },
        react_1["default"].createElement(IconButton_1["default"], null,
            react_1["default"].createElement(Search_1["default"], { color: "primary" })))); });
}
var stackDetailColumn = function (selectRow) {
    return lastColumn(function (id) { return (react_1["default"].createElement(IconButton_1["default"], { color: "primary", onClick: function () { return selectRow(id); } },
        react_1["default"].createElement(Search_1["default"], null))); });
};
var deleteColumn = function (onDelete) {
    return lastColumn(function (id) { return (react_1["default"].createElement(delete_1.DeleteWRedirect, { promise: onDelete, id: id, link: window.location.pathname, UI: function (props) { return (react_1["default"].createElement(DeleteIconButton, { onClick: props.onClick, "data-testid": "delete-button", color: "primary" },
            react_1["default"].createElement(Delete_1["default"], null))); } })); });
};
exports.routesFromPrefix = function (detailUrlPrefix) {
    var addAndDetailPrefix = '/' + (detailUrlPrefix ? detailUrlPrefix + "/" : '');
    return {
        add: addAndDetailPrefix + "add",
        detail: addAndDetailPrefix + ":uuid"
    };
};
exports.dataDefToColumns = function (dataDef, selectRow, onDelete) {
    var _a;
    var urlPrefix = dataDef.urlPrefix, fields = dataDef.fields, detailUrlPrefix = dataDef.detailUrlPrefix, detailPage = dataDef.detailPage;
    var d = fields
        .filter(function (x) {
        if (typeof x.hideInList !== 'undefined') {
            console.warn("Usage of 'hideInList' are deprecated and won't be supported in the future. Please use 'hide: { list: true }' instead.");
        }
        return Utils.shouldShowFieldInList(x);
    })
        .map(function (x) { return ({
        name: x.name,
        label: x.label,
        options: x.options,
        render: x.render,
        filter: x.filter,
        sort: x.sort
    }); });
    if (((_a = dataDef.displayType) === null || _a === void 0 ? void 0 : _a.detail) !== false) {
        if (detailPage === 'stack' && selectRow) {
            d.push(stackDetailColumn(selectRow));
        }
        else {
            d.push(linkDetailColumn(urlPrefix, detailUrlPrefix));
        }
    }
    else {
        if (dataDef.displayType["delete"] === true && onDelete) {
            d.push(deleteColumn(onDelete));
        }
    }
    return d;
};
